import script from "./supplement-barcode.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement-barcode.vue?vue&type=script&setup=true&lang=js"

import "./supplement-barcode.vue?vue&type=style&index=0&id=545dfd3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545dfd3e"]])

export default __exports__